<template>
  <div
    :class="['c-card', `-level-${level}`]"
    :style="cardStyle"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CCard',
  props: {
    padding: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 1,
    },
    containsList: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardStyle() {
      if (this.padding) {
        return { padding: '2rem 3rem' };
      }
      if (this.containsList) {
        return {
          paddingTop: '.4rem',
          paddingBottom: '.4rem',
        };
      }
      return {};
    },
  },
};
</script>

<style
    lang="scss"
    type="text/scss"
>
  @import "shared/assets/scss/box-shadow";

  .c-card {
    background: white;
    border-radius: $border-radius;

    @include box_shadow(1);

    &.-level-2 {
      @include box_shadow(2);
    }

    .c-card-item {
      margin: 0 .4rem;
    }
  }
</style>
